import React from 'react';

import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 0;
  min-height: 320px;
`;

const UserManagementFeatureFlagsModalContent = ({ children }: { children: React.ReactNode }) => (
  <Content>{children}</Content>
);

export default UserManagementFeatureFlagsModalContent;
